<ng-container [formGroup]="valueForm">
  <div class="d-flex align-items-center">
    @if (showLabel) {
      <label class="text-secondary">{{ label }}</label>
    }

    <ellf-operators
      class="ms-auto"
      [items]="operators"
      name="operator"
      formControlName="operator"
      [readOnly]="readOnly"
    ></ellf-operators>

    <i
      class="icon ms-1 text-danger feather icon-x"
      [style.visibility]="showClear() ? 'visible' : 'hidden'"
      (click)="clear(true)"
    ></i>
    <!-- x-circle -->
  </div>
  <div class="d-flex align-items-center" formArrayName="value">
    @for (valueControl of valueArray.controls; track valueControl; let i = $index) {
      @if (i === 1) {
        <span>&nbsp;</span>
      }
      @if (type === filterTypes.text) {
        <ellf-text-input
          class="flex-grow-1"
          name="value"
          [readOnly]="readOnly || false"
          [formControl]="$any(valueControl)"
          >
        </ellf-text-input>
      }
      @if (type === filterTypes.number) {
        <ellf-numeric-input
          class="flex-grow-1"
          name="value"
          [readOnly]="readOnly || false"
          [formControl]="$any(valueControl)"
          [showGroupSeparator]="false"
          >
        </ellf-numeric-input>
      }
      @if (type === filterTypes.date || type === filterTypes.datetime) {
        <ellf-datepicker
          class="flex-grow-1"
          name="value"
          [showIcon]="false"
          [readOnly]="readOnly || false"
          [formControl]="$any(valueControl)"
          >
        </ellf-datepicker>
      }
      @if (type === filterTypes.enum || type === filterTypes.boolean) {
        <ellf-select
          class="flex-grow-1"
          name="value"
          [items]="items"
          [clearable]="false"
          [bindValue]="'value'"
          [formControl]="$any(valueControl)"
          [appendTo]="'body'"
          [dropdownPosition]="'bottom'"
          [readOnly]="readOnly || false"
          >
        </ellf-select>
      }
      @if (type === filterTypes.autocomplete) {
        <div
          class="position-relative decode"
          >
          <input
            #decodeInput
            type="text"
            class="form-control"
            [formControl]="$any(valueControl)"
            [ngbTypeahead]="search"
            [showHint]="true"
            [editable]="false"
            [container]="'body'"
            [readOnly]="readOnly || false"
            (selectItem)="selected($event, $any(valueControl))"
            (blur)="blur(decodeInput, $any(valueControl))"
            />
          @if (autocompleteLoading) {
            <div
              class="spinner-border spinner-border-sm text-primary"
              role="status"
              >
              <span class="visually-hidden">Caricamento...</span>
            </div>
          }
        </div>
      }
    }
  </div>

  <!-- <strong>
  {{ valueForm.value | json }}
</strong> -->
</ng-container>
